import { showNotification } from "@mantine/notifications";
import { MedplumClient } from "@medplum/core";
import { DocumentReference } from "@medplum/fhirtypes";

export async function availityEdiBotHandler(medplum: MedplumClient, payload: any) {
    try {
        const response = await medplum.executeBot(
            {
                system: "https://api-stage.healthconnect.systems/bots",
                value: "availity-edi-service",
            },
            payload
        );
        if (response?.status && response?.status > 300) throw new Error(response.message??'Something Went Wrong');
        return response

    } catch (error) {
        console.log(error);
        showNotification({
            color: "red",
            message: error as any,
        });

    }
}

export const mapClaimResponses = (
    patientDetails: Record<string, string>,
    claimResponses: any
) => {
    return claimResponses.map((claimResponse: any) => {
        // Extract patient ID from the claim response
        const patientReference = claimResponse.patient.reference;
        const patientId = patientReference.split("/")[1]; // Get the ID part of the reference

        // Retrieve the patient name from the patientDetails object
        const patientName = patientDetails[patientId] || "Unknown Patient"; // Fallback to "Unknown Patient" if not found

        // Return the desired claim response information along with the patient name
        return {
            patientName, // Retrieved or fallback patient name
            claimId: claimResponse.id, // Claim ID
            provider: '$1500', // Claim ID
            subType: claimResponse.type?.coding?.[0]?.code || "--", // Claim type display (e.g., "Institutional")
            type: claimResponse.subType?.coding?.[0]?.display || "--", // Claim subtype (e.g., "Emergency Claim")
            created: claimResponse.created, // Date of creation
            insurer: claimResponse.insurer.display ?? '--', // Insurer information
            outcome: claimResponse.outcome, // Outcome/status of the claim (e.g., "partial")
            paymentAmount: claimResponse.payment?.amount?.value || 0, // Payment amount if present
        };
    });
};



export const getCoverageEligibilityResponseForPatient = async (medplum: MedplumClient, patientId: any) => {
    const response = await medplum.searchResources('CoverageEligibilityResponse', `_count=20&_offset=0&_sort=-_lastUpdated&_total=accurate&patient=Patient/${patientId}`)
    return response;
}
export function findObjectById(id: any, dataArray: any) {
    return dataArray
        ?.filter((obj: any) => obj?.id === id)
        ?.map((obj: any) => {
            // Specify the fields you want to return here
            return {
                resourceType: obj.resourceType,
                status: obj.status,
                patientReference: obj.patient?.reference,
                identifier: obj?.identifier,
                servicedPeriod: obj.servicedPeriod,
                insurerReference: obj.insurer?.reference,
                outcome: obj.outcome,
                insuranceItems: obj.insurance?.map((insurance: any) => ({
                    coverageReference: insurance.coverage?.reference,
                    inforce: insurance.inforce,
                    items: insurance.item?.map((item: any) => ({
                        category: item.category?.text,
                        name: item.name,
                        description: item.description,
                        benefits: item.benefit?.map((benefit: any) => ({
                            type: benefit.type?.text,
                            allowedString: benefit.allowedString
                        }))
                    }))
                }))
            };
        })[0] || null; // Return the first match or null if not found
}
export function findClaimObjectById(id: any, dataArray: any) {
    return dataArray
        ?.filter((obj: any) => obj?.id === id)
        ?.map((obj: any) => {
            // Specify the fields you want to return here
            return {
                obj
            };
        })[0] || null; // Return the first match or null if not found
}
export const patientDetailsFromId = async (medplum: MedplumClient, id: any) => {
    try {
        const response = await medplum.searchResources("Patient", `_count=20&_id=${id}&_offset=0&_sort=-_lastUpdated&_total=accurate`)
        return response

    } catch (error) {
        console.error(error)
    }
}
export const getClaimResponse = async (medplum: MedplumClient, id: any) => {
    try {
        const response = await medplum.searchResources('ClaimResponse', `use=preauthorization&_count=20&_offset=0&_sort=-_lastUpdated&_total=accurate&patient=Patient/${id}`)
        return response
    } catch (error) {
        console.log(error)
    }
}

export const fetchCovergaeResource = async (medplum: MedplumClient, coverageId: any) => {
    try {
        const response = await medplum.searchResources('Coverage', `_count=20&_id=${coverageId}&_offset=0&_sort=-_lastUpdated&_total=accurate`)
        return response
    } catch (error) {
        console.error(error)

    }
}


export async function runTimer(setProgress: any, index: number, isDone: boolean): Promise<void> {
    return new Promise((resolve) => {
        let count = 1;

        const interval = setInterval(() => {
            const progress = count * 10;
            setProgress((prev: any) => ({ ...prev, [index]: { currentProgress: progress, isComplete: isDone } }));

            if (count >= 10) {
                clearInterval(interval);
                resolve();
            }
            count++;
        }, 300);
    });
}



const renderReport = (report: string, name: string) => {
name = name.split(" ").reverse().join(", ");

const replaceMap = {
    'DOE, JOHN': name,
    'DOE*JOHN': name.replace(", ", "*"),
    '2024-10-14': new Date().toISOString().split('T')[0],
    '10/15/2023': new Date().toISOString().split('T')[0],
}

for (const [key, value] of Object.entries(replaceMap)) {
    report = report.replaceAll(key, value);
}
return report
}


export const getEdiFiles = async (medplum: MedplumClient, claimResponse: any, extUrl: string, patName: string) => {
    const docRef = claimResponse.extension?.find((ext: any) => ext.url === extUrl)?.valueReference;
    if (docRef) {
        const doc = await medplum.readReference(docRef) as DocumentReference;
        const binaryRef = doc.content?.[0].attachment?.url;
        //Return text
        const binary = await availityEdiBotHandler(medplum, { request: 'readFil', params: { fileUrl: binaryRef } })
        if (binary.status === 200) {
            return {
                name: doc?.description ?? '--',
                body: renderReport(binary.body, patName), //binary.body
            };
        }
        // else showNotification({
        //     color: "red",
        //     message: "Failed to fetch EDI file",
        //     autoClose: true,
        // });

    }
    return null;
}

export const getUpdatedClaimRes = async (medplum: MedplumClient, id: string) => {
    const response = await availityEdiBotHandler(medplum, { request: 'getEdiFiles', params: { clResId: id } });
  
    return response.body ;
}

export const submitClaim = async (medplum: MedplumClient, formData: any) => {
    const response = await availityEdiBotHandler(medplum, { request: 'submitClaim', params: formData });
    return response
}

